<div class="content-style-class" [style.filter]="showLoader === true ? 'blur(0.2rem)' : 'blur(0)'">
    <div class="content-block">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="column">
                <h2 class="title-style">{{dataService.res('Cmt-Measure-Benefit-Title')}}</h2>
            </div>
            <div fxLayout="column" class="add-button-style">
                <dx-button fxLayoutAlign="end" [text]="dataService.res('Cmt-Measure-Benefit-Create')" icon="add"
                    style="width: fit-content;" (onClick)="addRow()">
                </dx-button>
            </div>
        </div>
        <div class="dx-card responsive-paddings">
            <ww-grid #MeasureBenefitGrid [columnsHeader]='columnsHeader' [gridData]='measureBenefitList'
                class="grid-group-by-style" [enableStateStorage]="false" (onSaved)="persistMeasureBenefit($event)"
                [showRowLines]="true" [enableColumnChooser]="false" [editingMode]='"row"' [allowAdding]="false">
            </ww-grid>
        </div>
    </div>
</div>
<cmt-loader *ngIf="showLoader"></cmt-loader>